import axios from 'axios';
import { Announcement } from '../models/Announcement';
import { Collection } from '../models/Collection';

export const fetchAnnouncementDictionary = async () => {
  const response = await axios.get<Collection<Announcement>>('/inventory/announcements/dictionary');
  return response.data.items.filter(def => def.active && def.text);
};
